/* tslint:disable */
/* eslint-disable */
/**
 * LPPSWebApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { formatDateOnly, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CalculationSettingsUploadResult
 */
export interface CalculationSettingsUploadResult {
    /**
     * 
     * @type {number}
     * @memberof CalculationSettingsUploadResult
     */
    rowsAdded?: number;
    /**
     * 
     * @type {number}
     * @memberof CalculationSettingsUploadResult
     */
    rowsRemoved?: number;
    /**
     * 
     * @type {number}
     * @memberof CalculationSettingsUploadResult
     */
    rowsUpdated?: number;
}

/**
 * Check if a given object implements the CalculationSettingsUploadResult interface.
 */
export function instanceOfCalculationSettingsUploadResult(value: object): value is CalculationSettingsUploadResult {
    return true;
}

export function CalculationSettingsUploadResultFromJSON(json: any): CalculationSettingsUploadResult {
    return CalculationSettingsUploadResultFromJSONTyped(json, false);
}

export function CalculationSettingsUploadResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): CalculationSettingsUploadResult {
    if (json == null) {
        return json;
    }
    return {
        
        'rowsAdded': json['rowsAdded'] == null ? undefined : json['rowsAdded'],
        'rowsRemoved': json['rowsRemoved'] == null ? undefined : json['rowsRemoved'],
        'rowsUpdated': json['rowsUpdated'] == null ? undefined : json['rowsUpdated'],
    };
}

export function CalculationSettingsUploadResultToJSON(json: any): CalculationSettingsUploadResult {
    return CalculationSettingsUploadResultToJSONTyped(json, false);
}

export function CalculationSettingsUploadResultToJSONTyped(value?: CalculationSettingsUploadResult | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'rowsAdded': value['rowsAdded'],
        'rowsRemoved': value['rowsRemoved'],
        'rowsUpdated': value['rowsUpdated'],
    };
}

